






import {Component} from "vue-property-decorator";
import {ConfigurationRepository} from "@api/repositories/ConfigurationRepository";
import {RepositoryFabric} from "@api/repositories/RepositoryFabric";
import {DateTime} from "luxon";

import { getBackend } from "@service/router/getters";
import { addStylesToHead } from "@service/helpers/domHelper";
import { STYLES_FROM_CONFIG_NAME } from "@common/constants";
import { AuthRepository } from "@api/repositories/AuthRepository";
import { UserProfile } from "@api/models/UserProfile";
import AuthFormProcessor from "./AuthFormProcessor.vue";

@Component
export default class ExternalAuth extends AuthFormProcessor {
    configurationRepository: ConfigurationRepository;

    async mounted() {
        this.$store.dispatch('showSpinner');

        try {
            this.configurationRepository = this.$repositories.get(RepositoryFabric.CONFIGURATION);
        }
        catch (e) {
            this.$store.dispatch('reportException', e);
        }

        try {
            await this.fetchConfiguration();
        }
        catch (e) {
         console.log(e);
         this.notFound();
        }
        this.$store.dispatch('hideSpinner');
        this.$store.dispatch("setFavicon", getBackend(this.$route.params.backend));
        this.$store.dispatch("setPageTitle");
    }

    async fetchConfiguration() {
        const configuration = await this.configurationRepository.appropriateConfiguration('Web');
        if (!configuration) {
            this.notFound();
            return;
        }
        if(configuration.commonCss) {
            addStylesToHead(configuration.commonCss, STYLES_FROM_CONFIG_NAME);
        }

        this.$store.commit('services/setCommonCss', {
            css: configuration.commonCss,
            backend: getBackend(this.$route.params.backend)
        });

        if (configuration.servicesParams) {
            this.$store.commit('services/setUpdateTime', DateTime.local());
            configuration.servicesParams.forEach(service => {
                if (this.$store.getters['services/isValidServiceName'](service.name)) {
                    this.$store.commit('services/setServiceParams', {
                        service: service,
                        backend: getBackend(this.$route.params.backend)
                    });
                }
            });
        }
        this.$emit('configLoaded');

        // ANON:
        /**
         * app might me used anonymously
         */
        if(this.$store.getters['useAnonym'] ) {

            const authRepository = this.$repositories.get<AuthRepository>(RepositoryFabric.AUTH);
            const profile = new UserProfile({})
            const sessionData = await authRepository.loginAnonymous(profile);

            sessionData.backend = getBackend(this.$route.params.backend);

            this.$emit('loggedIn', sessionData);
        }
        else {
            configuration && this.processForm(configuration);
        }
    }

    //pass session to parent component
    async login(session: string) {
        try {
            const sessionObject = JSON.parse(session);
            if (sessionObject) {
                sessionObject.backend = getBackend(this.$route.params.backend);
                this.$emit('loggedIn', sessionObject);
            }
        }
        catch (e) {
            console.log(e, 'Неверный объект');
        }
    }
}
